import {
  FILTER_DISPLAY,
  SECONDARYFILTERS_NAMES
} from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { RangeField } from "@/modules/Dashboards/AdminDashboard/models/RangeField";
import {
  SecondaryFilter,
  SecondaryFilterOptions
} from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { TreeChildren } from "@/modules/Dashboards/AdminDashboard/models/TreeChilden";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DATA_TYPE_CONSULT,
  EVENT_EMITTER
} from "../../constants/GenericSearchConstants";
import { AllObjFilterList, FilterData } from "../../model/List";
import FilterTypeAll from "./../FilterTypeAll/FilterTypeAll.vue";
import FilterTypeDate from "./../FilterTypeDate/FilterTypeDate.vue";
import FilterTypeInput from "./../FilterTypeInput/FilterTypeInput.vue";
import FilterTypeRange from "./../FilterTypeRange/FilterTypeRange.vue";
import FilterTypeSelect from "./../FilterTypeSelect/FilterTypeSelect.vue";
import FilterTypeUnique from "./../FilterTypeUnique/FilterTypeUnique.vue";
import { SELECT_EVENTS } from "@/shared/constants/SelectConstants";

@Component({
  name: "FilterCollapse",
  components: {
    FilterTypeAll,
    FilterTypeInput,
    FilterTypeSelect,
    FilterTypeRange,
    FilterTypeDate,
    FilterTypeUnique
  }
})
export default class FilterCollapse extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() allItemFilter!: SecondaryFilter[];
  @Prop() filterData!: FilterData[];
  @Prop() allSelectFilter!: AllObjFilterList;
  @Prop({ default: () => [] }) ItemsShemaRange!: RangeField[];
  @Prop({ default: () => [] }) itemsSchema!: TreeChildren[];
  @Prop({ default: () => "" }) attachRef!: string;
  @Prop({ default: () => 0 }) clearFilter!: number;

  FILTER_DISPLAY = FILTER_DISPLAY;
  allFilterDelete = {};
  panels: number[] | number = [];
  multiplePanel = false;

  mounted() {
    this.closePanel();
  }

  @Watch("clearFilter")
  closePanel() {
    this.panels = this.multiplePanel ? [] : -1;
  }

  showChip(indexPanel: number): boolean {
    return (
      (this.multiplePanel &&
        ((this.panels ?? []) as number[]).includes(indexPanel)) ||
      (!this.multiplePanel && ((this.panels ?? -1) as number) == indexPanel)
    );
  }

  callData(data: SecondaryFilterOptions) {
    this.$emit(EVENT_EMITTER.CALL_DATA, data);
  }

  removeFilterSelect(filter: SecondaryFilter, indexChip: number) {
    const indexPanel = filter.key;
    this.allSelectFilterLocal[indexPanel].splice(indexChip, 1);
    if (filter.display != FILTER_DISPLAY.INPUT) {
      this.closePanel();
    }
    this.childrenReload(filter);
    this.$forceUpdate();
  }

  change() {
    this.$emit(EVENT_EMITTER.CHANGE);
  }

  get allSelectFilterLocal() {
    return this.allSelectFilter;
  }

  set allSelectFilterLocal(allFilterSelected: AllObjFilterList) {
    this.$emit(EVENT_EMITTER.UPDATE_ALL_SELECT_FILTER, allFilterSelected);
  }

  isMultipleOption(nameFilter: string): boolean {
    return Utils.isMultipleOption(
      nameFilter,
      this.allSelectFilter,
      this.allItemFilter
    );
  }

  isDisabled(filter: SecondaryFilter) {
    const nameFilter = filter.key;

    if (
      filter.display == FILTER_DISPLAY.SCHEMA ||
      filter.display == FILTER_DISPLAY.SCHEMA_RANGE
    ) {
      const filterSelect =
        this.allSelectFilter[DATA_TYPE_CONSULT.FORM.FORM_TEMPLATE]?.length ||
        this.allSelectFilter[DATA_TYPE_CONSULT.USER.USER_TEMPLATE]?.length ||
        0;

      if (
        !filterSelect &&
        filter.key !== SECONDARYFILTERS_NAMES.CUSTOM_ORDER_FIELDS
      ) {
        return true;
      }
    }

    if (
      filter.display == FILTER_DISPLAY.DATE ||
      filter.display == FILTER_DISPLAY.SCHEMA ||
      filter.display == FILTER_DISPLAY.SCHEMA_RANGE ||
      filter?.notSelect
    ) {
      for (const nameFilterSelect of Object.keys(this.allSelectFilter)) {
        const filterSelect = this.allItemFilter.find(
          filterSelect => filterSelect.key == nameFilterSelect
        );
        const filtern = this.allSelectFilter[nameFilterSelect];
        if (
          nameFilterSelect != nameFilter &&
          (filterSelect?.display === FILTER_DISPLAY.DATE ||
            filterSelect?.display == FILTER_DISPLAY.SCHEMA ||
            filterSelect?.display == FILTER_DISPLAY.SCHEMA_RANGE ||
            (filter?.notSelect &&
              filter.notSelect.includes(filterSelect?.key ?? ""))) &&
          filtern &&
          filtern.length >= 1
        ) {
          return true;
        }
      }
    }
    return false;
  }

  getReload(filter: SecondaryFilter) {
    return filter.reload ?? 0;
  }

  childrenReload(filter: SecondaryFilter) {
    filter.childrenReload?.forEach(fieldKey => {
      this.allSelectFilterLocal[fieldKey] = [];
      const filter = this.allItemFilter.find(x => x.key == fieldKey);
      if (filter) {
        filter.options = [];
        filter.reload = 1 - (filter.reload ?? 0);
      }
    });
  }

  detectScroll() {
    if (this.panels == undefined || this.panels == -1) {
      return;
    }
    const panels = typeof this.panels == "number" ? [this.panels] : this.panels;

    panels.forEach(i => {
      const ref = "filterTypeAll" + i;
      Utils.detectScroll(this.$refs, ref);
    });
  }

  fetchData(keyWord: string) {
    this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA, keyWord);
  }
}
